import React from 'react';
import { services } from '../mock';
import {
  UserSearch,
  ClipboardCheck,
  ShieldCheck,
  CalendarClock,
  FileBadge,
  Plane,
  GraduationCap,
  Handshake,
  ArrowRight,
} from 'lucide-react';

const ICONS = {
  UserSearch,
  ClipboardCheck,
  ShieldCheck,
  CalendarClock,
  FileBadge,
  Plane,
  GraduationCap,
  Handshake,
};

export default function Services() {
  return (
    <section id="services" className="jh-section jh-dot-bg relative">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="text-center mb-16 max-w-3xl mx-auto">
          <span className="jh-eyebrow">Our Recruitment Services</span>
          <h2 className="jh-h2 text-[#0e1421] mt-4">
            End-to-End International Recruitment Solutions
          </h2>
          <p className="text-gray-600 mt-5 leading-relaxed">
            We partner with employers across a range of industries to provide
            ethical, transparent and government-compliant recruitment
            solutions.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((s) => {
            const Icon = ICONS[s.icon] || Handshake;
            return (
              <div key={s.title} className="jh-card group cursor-pointer">
                <div className="jh-icon-wrap">
                  <Icon size={40} strokeWidth={1.6} />
                </div>
                <h3 className="jh-h3 text-[#0e1421] mb-3">{s.title}</h3>
                <p className="text-[14.5px] text-gray-600 leading-relaxed">
                  {s.desc}
                </p>
                <div className="jh-arrow-circle">
                  <ArrowRight size={20} />
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
